import React from "react";
import { TextField } from "@mui/material";

const FieldInput = ({ label, name, value, onChange, type = "text" }) => {
  return (
    <TextField
      fullWidth
      placeholder={label}
      name={name}
      value={value}
      onChange={onChange}
      type={type} // Set the input type
      variant="outlined"
      sx={{
        "& .MuiOutlinedInput-root": {
          color: "white",
          "& fieldset": {
            borderColor: "rgba(255, 255, 255, 0.23)",
          },
        },
        "& .MuiInputLabel-root": {
          color: "gray",
        },
      }}
    />
  );
};

export default FieldInput;
